module.exports = __webpack_public_path__ + "img/ObenNebenFuesseUntenTransp.a5fd9604.png";